import { Link, useSidebarOpenState } from '@backstage/core-components';
import { makeStyles } from '@material-ui/core';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';
import { TOPBAR_HEIGHT } from './topBarLayout';

const useSidebarLogoStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    // Fixed to exactly TOPBAR_HEIGHT, with a border-bottom in place of the
    // separate <SidebarDivider/> that used to follow this — so this line
    // and TopBar's own border-bottom land at the exact same y-coordinate
    // instead of two independently-computed dividers drifting apart. Pulled
    // from the theme (not a hand-picked hex) so it stays correct if the
    // active theme's border color ever changes.
    height: TOPBAR_HEIGHT,
    boxSizing: 'border-box',
    borderBottom: `1px solid ${theme.palette.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    // The logo asset is cropped tight to its artwork (no baked-in margin
    // like the old raster asset had) — horizontal breathing room comes from
    // this padding; vertical centering comes from the flex box above.
    padding: '0 16px',
    overflow: 'hidden',
  },
  link: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    overflow: 'hidden',
  },
}));

export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};
